import { AxiosResponse } from 'axios';
import { Coordinate } from 'types/interfaces';

import { api } from '../../http';

export interface CoordinatesFilters {
  filters: string;
}

export interface CoordinatesResponse {
  relevantCoordinates: Coordinate[];
  expiredCoordinates: Coordinate[];
}

export const CoordinatesService = {
  getCoordinates(
    filters: CoordinatesFilters
  ): Promise<AxiosResponse<CoordinatesResponse>> {
    const searchParams = new URLSearchParams();

    if (filters.filters) {
      searchParams.append('filters', filters.filters);
    }

    return api.get<CoordinatesResponse>(
      `userCoordinates?${searchParams.toString()}`
    );
  }
};
